import PaintAfterSalesWorkspace from '../../placeholders/PaintAfterSalesWorkspace';

export default PaintAfterSalesWorkspace;
